import {
  Configuration,
  InsertsApi,
  InsertsTypesApi,
  type ConfigurationParameters,
} from '@teemill/inserts';
import type { App } from 'vue';

let insertsClient: InsertsApi;
let insertsTypesClient: InsertsTypesApi;

export const inserts = {
  install(
    app: App,
    options: {
      client: ConfigurationParameters;
    },
  ) {
    insertsClient = new InsertsApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    insertsTypesClient = new InsertsTypesApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
  },
};

export { insertsClient, insertsTypesClient };
